import React from 'react';
import ReactDOM from 'react-dom/client';

import '@/infra/i18n/index.js';
import { translate } from '@/infra/i18n/index.js';
import { useAuthStore } from '@/infra/stores/auth-store.js';
import { useProjectStore } from '@/infra/stores/project-store.js';
import { useThemeStore } from '@/infra/stores/theme-store.js';
import { ThemeAppProvider } from '@/infra/theme/theme-provider.js';
import { App } from '@/main/app.js';
import { AppContext, type AppContextValue } from '@/presentation/contexts/app-context.js';

const contextValue: AppContextValue = {
    translate,
    useAuthStore,
    useProjectStore,
    useThemeStore
};

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeAppProvider>
            <AppContext.Provider value={contextValue}>
                <App />
            </AppContext.Provider>
        </ThemeAppProvider>
    </React.StrictMode>
);
